import React from 'react';
import PropTypes from 'prop-types';

import { Delete } from 'jbc-front/components/icons';
import GeneralConfirmationBtn from './GeneralConfirmationBtn';
import i18next from 'i18next';

const DeleteBtn = ({ showingConfirmBox, confirmText, handleDelete, text, disabled, children, ...rest }) => {
  const innerChild = children || <Delete size={18} />;
  return (
    <GeneralConfirmationBtn
      {...{ showingConfirmBox, confirmText, text, disabled }}
      handleEvent={handleDelete}
      as="a"
      {...rest}
    >
      {innerChild}
    </GeneralConfirmationBtn>
  );
};

DeleteBtn.propTypes = {
  handleDelete: PropTypes.func.isRequired
};

DeleteBtn.defaultProps = {
  showingConfirmBox: true,
  confirmText: i18next.t('buttons.DeleteBtn.do_you_want_to_remove_the_data'),
  text: i18next.t('buttons.DeleteBtn.remove')
};

export default DeleteBtn;
